import _implicitStylesheets from "./statusBadge.css";
import _implicitScopedStylesheets from "./statusBadge.scoped.css?scoped=true";
import _axBadge from "ax/badge";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element} = $api;
  return [api_custom_element("ax-badge", _axBadge, {
    className: api_normalize_class_name($cmp.badgeClassName),
    props: {
      "text": $cmp.badgeLabel,
      "variant": $cmp.badgeDisplayVariant,
      "theme": $cmp.badgeTheme
    },
    key: 0
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-76or6cdei9p";
tmpl.legacyStylesheetToken = "undefined-_statusBadge";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
